// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CreatePasswordRouteImport } from './routes/create-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTeachersRouteImport } from './routes/_authenticated/teachers'
import { Route as AuthenticatedStudentsRouteImport } from './routes/_authenticated/students'
import { Route as AuthenticatedStudentBillsRouteImport } from './routes/_authenticated/student-bills'
import { Route as AuthenticatedStoreRouteImport } from './routes/_authenticated/store'
import { Route as AuthenticatedStaffAnnouncementsRouteImport } from './routes/_authenticated/staff-announcements'
import { Route as AuthenticatedSchoolRouteImport } from './routes/_authenticated/school'
import { Route as AuthenticatedSchedulesRouteImport } from './routes/_authenticated/schedules'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPaymentsRouteImport } from './routes/_authenticated/payments'
import { Route as AuthenticatedPaymentTypesRouteImport } from './routes/_authenticated/payment-types'
import { Route as AuthenticatedPaymentSettingsRouteImport } from './routes/_authenticated/payment-settings'
import { Route as AuthenticatedMembersRouteImport } from './routes/_authenticated/members'
import { Route as AuthenticatedGalleryRouteImport } from './routes/_authenticated/gallery'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedAttendanceRouteImport } from './routes/_authenticated/attendance'
import { Route as AuthenticatedAppUpdatesRouteImport } from './routes/_authenticated/app-updates'
import { Route as AuthenticatedAnnouncementsRouteImport } from './routes/_authenticated/announcements'
import { Route as AuthenticatedStoreIndexRouteImport } from './routes/_authenticated/store.index'
import { Route as AuthenticatedStoreSettingsRouteImport } from './routes/_authenticated/store.settings'
import { Route as AuthenticatedStoreProductsRouteImport } from './routes/_authenticated/store.products'
import { Route as AuthenticatedStoreCategoriesRouteImport } from './routes/_authenticated/store.categories'
import { Route as AuthenticatedStoreBannersRouteImport } from './routes/_authenticated/store.banners'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const CreatePasswordRoute = CreatePasswordRouteImport.update({
            id: '/create-password',path: '/create-password',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTeachersRoute = AuthenticatedTeachersRouteImport.update({
            id: '/teachers',path: '/teachers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStudentsRoute = AuthenticatedStudentsRouteImport.update({
            id: '/students',path: '/students',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStudentBillsRoute = AuthenticatedStudentBillsRouteImport.update({
            id: '/student-bills',path: '/student-bills',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStoreRoute = AuthenticatedStoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStaffAnnouncementsRoute = AuthenticatedStaffAnnouncementsRouteImport.update({
            id: '/staff-announcements',path: '/staff-announcements',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSchoolRoute = AuthenticatedSchoolRouteImport.update({
            id: '/school',path: '/school',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSchedulesRoute = AuthenticatedSchedulesRouteImport.update({
            id: '/schedules',path: '/schedules',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentsRoute = AuthenticatedPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentTypesRoute = AuthenticatedPaymentTypesRouteImport.update({
            id: '/payment-types',path: '/payment-types',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentSettingsRoute = AuthenticatedPaymentSettingsRouteImport.update({
            id: '/payment-settings',path: '/payment-settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMembersRoute = AuthenticatedMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedGalleryRoute = AuthenticatedGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAttendanceRoute = AuthenticatedAttendanceRouteImport.update({
            id: '/attendance',path: '/attendance',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppUpdatesRoute = AuthenticatedAppUpdatesRouteImport.update({
            id: '/app-updates',path: '/app-updates',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAnnouncementsRoute = AuthenticatedAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStoreIndexRoute = AuthenticatedStoreIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStoreRoute
          })
const AuthenticatedStoreSettingsRoute = AuthenticatedStoreSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedStoreRoute
          })
const AuthenticatedStoreProductsRoute = AuthenticatedStoreProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AuthenticatedStoreRoute
          })
const AuthenticatedStoreCategoriesRoute = AuthenticatedStoreCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AuthenticatedStoreRoute
          })
const AuthenticatedStoreBannersRoute = AuthenticatedStoreBannersRouteImport.update({
            id: '/banners',path: '/banners',getParentRoute: () => AuthenticatedStoreRoute
          })





const AuthenticatedStoreRouteChildren = {
  AuthenticatedStoreBannersRoute: AuthenticatedStoreBannersRoute,AuthenticatedStoreCategoriesRoute: AuthenticatedStoreCategoriesRoute,AuthenticatedStoreProductsRoute: AuthenticatedStoreProductsRoute,AuthenticatedStoreSettingsRoute: AuthenticatedStoreSettingsRoute,AuthenticatedStoreIndexRoute: AuthenticatedStoreIndexRoute
}

const AuthenticatedStoreRouteWithChildren = AuthenticatedStoreRoute._addFileChildren(AuthenticatedStoreRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAnnouncementsRoute: AuthenticatedAnnouncementsRoute,AuthenticatedAppUpdatesRoute: AuthenticatedAppUpdatesRoute,AuthenticatedAttendanceRoute: AuthenticatedAttendanceRoute,AuthenticatedChatRoute: AuthenticatedChatRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedGalleryRoute: AuthenticatedGalleryRoute,AuthenticatedMembersRoute: AuthenticatedMembersRoute,AuthenticatedPaymentSettingsRoute: AuthenticatedPaymentSettingsRoute,AuthenticatedPaymentTypesRoute: AuthenticatedPaymentTypesRoute,AuthenticatedPaymentsRoute: AuthenticatedPaymentsRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedSchedulesRoute: AuthenticatedSchedulesRoute,AuthenticatedSchoolRoute: AuthenticatedSchoolRoute,AuthenticatedStaffAnnouncementsRoute: AuthenticatedStaffAnnouncementsRoute,AuthenticatedStoreRoute: AuthenticatedStoreRouteWithChildren,AuthenticatedStudentBillsRoute: AuthenticatedStudentBillsRoute,AuthenticatedStudentsRoute: AuthenticatedStudentsRoute,AuthenticatedTeachersRoute: AuthenticatedTeachersRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,CreatePasswordRoute: CreatePasswordRoute,ForgotPasswordRoute: ForgotPasswordRoute,ResetPasswordRoute: ResetPasswordRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)